import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from "react-router-dom";

import { routeCodes } from './../../routes'

export default function Breadcrumb(props) {
  return (
    <BreadcrumbNav aria-label="breadcrumbs">
      <BreadcrumbList>
        <BreadcrumbListItem>
          <BreadcrumbLink to={ routeCodes.HOME }>Homepage</BreadcrumbLink>
        </BreadcrumbListItem>
        <BreadcrumbListItem active={ true }>
          <BreadcrumbLink to="#" aria-current="page">{ props.active }</BreadcrumbLink>
        </BreadcrumbListItem>
      </BreadcrumbList>
    </BreadcrumbNav>
  );
}

Breadcrumb.propTypes = {
  props: PropTypes.string,
};

const BreadcrumbNav = styled.nav`
  font-size: 1rem;
  white-space: nowrap;
  user-select: none;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(10, 10, 10, 0.1);
`;

const BreadcrumbList = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const BreadcrumbListItem = styled.li`
  align-items: center;
  display: flex;

  &:not(:first-child) {
    &::before {
      color: #b5b5b5;
      content: '\0002f';
    }
  }

  &:last-child {
    a {
      color: #696969;
      cursor: default;
    }
  }
`;

const BreadcrumbLink = styled(Link)`
  align-items: center;
  color: #3273dc;
  display: flex;
  justify-content: center;
  padding: 0 0.75em;
`;